import { render, staticRenderFns } from "./DatasetForm.vue?vue&type=template&id=58bab7db"
import script from "./DatasetForm.vue?vue&type=script&lang=js"
export * from "./DatasetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports